import React from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from "reactstrap";
import { connect } from "react-redux";
import ReactLoading from "react-loading";
import moment from "moment";
import { Link } from "react-router-dom";
import Countdown from "react-countdown";

import { doGetMidtransPaymentDetail, doGetPayment, doFetchProductAddon } from "../../actions/paymentAction";
import withScrollTo from "../hoc/withScrollTo";
import ButtonSnapPay from "../Forms/ButtonSnapPay";
import ModalOutOfStock from "../Modals/ModalOutOfStock";
import { Container, Box, Text } from "./styled";
import Header from "./Header";
import Icon from "./Icon";
import Content from "./Content";
import { isFromKickApp, emptyImage, getCloudImageUrl, convertToRupiah } from "../../utils";

/* UTILS / HELPERS */
import { getQueryParamsUrl } from "../../helpers/url";
import { getStatusText, getStatusDetailText } from "../../helpers/snap";
import {
  DEFAULT_PAYMENT_METHOD,
  PAYMENT_LOGOS
} from "../../constants/paymentMethods"
import {API_BASE_URL} from "../../constants"

/* ASSETS */
import StopWatch from "../../images/stopwatch.png";
import Copy from "../../images/copyIcon.png"
import PendingIcon from "../../images/stopwatch.png";
import ErrorIcon from '../../images/icons/error.png';
import TimesUpIcon from '../../images/icons/times-up.png';
import SuccessIcon from '../../images/icons/success.png';

moment.locale("en");

const isShowStatusCode = statusCode => parseInt(statusCode) >= 400;

const NOT_CONFIRM_PAYMENT_MSG = "COMPLETE YOUR PAYMENT";

const HAS_CONFIRM_PAYMENT_MSG = "SEE INSTRUCTIONS";

const renderer = ({ days, hours, minutes, seconds, completed, ...props }) => {
  const newHours = days * 24 + hours;
  return (
    <p>
      {newHours === 0 ? "00 " : newHours}:{minutes === 0 ? " 00 " : minutes}:{seconds === 0 ? " 00" : seconds}
    </p>
  );
};

class PagePaymentResult extends React.Component {
  constructor(props) {
    super(props);
    //Example request from midtrans http://localhost:3000/payments/results?order_id=KA-270319-SSD-FHU&status_code=201&transaction_status=pending
    const params = Object.assign(
      { orderId: "", statusCode: 0, transactionStatus: "pending" },
      getQueryParamsUrl(props.location.search)
    );
    this.state = {
      _params: params,
      _totalAmount: 0,
      _isTopup: /^TU-/.test(params.orderId),
      _bankCode: null,
      _expiredAt: null,
      _paymentType: "-",
      // _vaType: null,
      _vaNumber: null,
      _trxToken: null,
      _redirectUrl: null,
      _trxId: null,
      _isOpenAlert: false,
      offer_amount: "",
      administration_fee: "",
      discount: "",
      subsidy_price: "",
      ka_courier_price: "",
      actual_total_amount: "",
      ka_courier_option: "",
      expiry: "",
      user_sell: {},
      addOnProduct: []
    };
  }

  componentDidMount() {
    this.props.getMidtransDetail(this.state._params.orderId);
    this.props.getPaymentDetail(this.state._params.orderId);
    this.props.doFetchProductAddon()

    if (isFromKickApp()) {
      if (window.Intercom) {
        window.Intercom("update", {
          hide_default_launcher: true
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataMidtrans.isFetch && !this.props.dataMidtrans.isFetch) {
      const { error, data } = this.props.dataMidtrans;
      if (!error) {
        this.setState({
          _params: {
            ...this.state._params,
            transactionStatus: data.is_expired ? "expire" : data.status
          },
          _totalAmount: data.gross_amount,
          _bankCode: data.va_type,
          _expiredAt: data.expired_at,
          _paymentType: data.payment_type,
          bank: data.bank,
          // _vaType: data.va_type,
          _redirectUrl: data.redirect_url,
          _trxToken: data.transaction_token,
          _trxId: data.transaction_id,
          _vaNumber: data.va_number
            ? data.va_number
              .split("")
              .map((c, index) => {
                if (
                  (data.status !== "pending" || data.is_expired) &&
                  index > 2
                )
                  return "X";
                return c;
              })
              .join("")
            : null,
          _errorMidtrans: null
        });
      } else {
        const { status_code } = error;
        if (status_code === 404) this.props.history.replace("/404");
        else
          this.setState({
            _errorMidtrans: { ...error },
            _params: {
              ...this.state._params,
              transactionStatus: status_code
            }
          });
      }
    }

    if (prevProps.paymentDetail.isFetch && !this.props.paymentDetail.isFetch) {
      if (this.props.paymentDetail.status_code === 200) {
        const {
          data: {
            offer_amount,
            administration_fee,
            discount,
            subsidy_price,
            ka_courier_price,
            actual_total_amount,
            ka_courier_option,
            expiry,
            user_sell
          }
        } = this.props.paymentDetail
        this.setState({
          offer_amount,
          administration_fee,
          ka_courier_option,
          discount,
          subsidy_price,
          ka_courier_price,
          actual_total_amount,
          expiry,
          user_sell
        })
      }
    }

    if (prevProps.productAddon !== this.props.productAddon && this.props.productAddon.data && this.props.productAddon.data.length > 0) {
      const { data } = this.props.productAddon || {}
      this.setState({
        addOnProduct: data
      })
    }
  }

  _handleOnSuccess = r => {
    //Harusnya sih gak pernah kesini...
    this.setState({
      _snapResponse: {
        ...this.state._snapResponse,
        data: { ...r },
        error: null
      }
    });
  };

  _handleOnPending = r => {
    const {
      transaction_id,
      payment_type,
      va_numbers,
      permata_va_number,
      bni_va_number,
      bca_va_number,
      bill_key,
      biller_code
    } = r;
    let { _vaNumber, _trxId, _bankCode } = this.state;
    if (transaction_id) {
      _trxId = transaction_id;
    }
    if (payment_type === "echannel") {
      _vaNumber = `${biller_code} ${bill_key}`;
      _bankCode = "MANDIRI";
    } else {
      if (va_numbers && va_numbers.length) {
        _vaNumber = va_numbers[0].va_number;
        _bankCode = va_numbers[0].bank.toUpperCase();
      } else if (permata_va_number) {
        _vaNumber = permata_va_number;
        _bankCode = "PERMATA";
      } else if (bni_va_number) {
        _vaNumber = bni_va_number;
        _bankCode = "BNI";
      } else if (bca_va_number) {
        _vaNumber = bca_va_number;
        _bankCode = "BCA";
      }
    }
    this.setState({
      _snapResponse: {
        ...this.state._snapResponse,
        data: { ...r },
        error: null
      },
      _trxId,
      _vaNumber,
      _bankCode
    });
  };

  _handleOnToggleAlert = () => {
    this.setState({ _isOpenAlert: !this.state._isOpenAlert });
  };

  _handleOnSubmitAlert = async e => {
    await this._handleOnToggleAlert();
    this.buttonPayRef._handleOpenSnap();
  };

  _handleOnError = e => {
    const { status_code } = e;
    this.setState({
      _snapResponse: {
        ...this.state._snapResponse,
        error: { ...e }
      },
      _params: {
        ...this.state._params,
        transactionStatus: parseInt(status_code) === 407 ? "expire" : "failure",
        statusCode: status_code
      }
    });
  };

  _handleExpiredCountdown = () => {
    const { _vaNumber } = this.state;
    this.setState({
      _params: {
        ...this.state._params,
        transactionStatus: "expire"
      },
      _vaNumber:
        _vaNumber &&
        _vaNumber
          .split("")
          .map((c, index) => {
            if (index > 2) return "X";
            return c;
          })
          .join("")
    });
  };

  renderPaymentMethodName = (method) => {
    switch (method) {
      case "bca":
        return "BCA Installment"
      case "mandiri":
        return "MANDIRI Installment"
      default:
        return 'Credit Card / Debit Card / Installments'
    }
  }

  renderPaymentMethodLogo = (method) => {
    switch (method) {
      case "bca":
      case "mandiri":
        return PAYMENT_LOGOS[`${method}`]
      default:
        return PAYMENT_LOGOS["masterCard"]
    }
  }

  getStatusIcon = (paymentStatus) => {
    switch (paymentStatus) {
      case 'authorize':
      case 'pending': return PendingIcon;
      case 'expire': return TimesUpIcon;
      case 'capture':
      case 'settlement': return SuccessIcon;
      default: return ErrorIcon;
    }
  }

  render() {
    const detailText = getStatusDetailText(
      this.state._params.transactionStatus
    );
    const isShowCode = isShowStatusCode(this.state._params.statusCode);
    const {
      offer_amount,
      administration_fee,
      discount,
      subsidy_price,
      ka_courier_price,
      actual_total_amount,
      ka_courier_option,
      user_sell,
      addOnProduct,
      expiry,
      _params,
      bank,
      _totalAmount
    } = this.state

    const { product_variant_images, product = {}, product_variant = {} } = user_sell;
    const haveImages =
      product_variant_images !== undefined
        ? product_variant_images.length > 0
        : false;

    const filteredProductAddOn = addOnProduct.length > 0 && addOnProduct.filter(addon => addon.name === ka_courier_option)
    return (
      <>
        <Container className="main-container page-container">
          <ModalOutOfStock
            isOpen={this.state._isOpenAlert}
            onToggle={this._handleOnToggleAlert}
            message="Oops! You have not completed your payment. Would you like to complete it now?"
            onButtonPrimaryClick={this._handleOnSubmitAlert}
            buttonPrimaryText="Proceed to payment completion"
            isCloseable
          />
          <Row>
            <Col>
              <Box>
                <Header
                  isTopup={this.state._isTopup}
                  title={`${getStatusText(
                    this.state._params.transactionStatus
                  )} ${detailText ? detailText : ""}`}
                />
                {isShowCode ? (
                  <Text style={{ margin: 0 }}>
                    code: {this.state._params.statusCode}
                  </Text>
                ) : null}
                <Icon
                  transactionStatus={this.state._params.transactionStatus}
                  expiredAt={this.state._expiredAt}
                  onExpired={this._handleExpiredCountdown}
                />
                <Content
                  // productName={this.state._productName}
                  orderId={this.state._params.orderId}
                  totalAmount={this.state._totalAmount}
                  vaNumber={this.state._vaNumber}
                  paymentMethod={this.state._paymentType}
                  bankCode={this.state._bankCode}
                />
                {this.state._params.transactionStatus === "pending" &&
                  this.state._expiredAt ? (
                  <Text style={{ marginTop: "1rem" }}>
                    Please complete your payment before{" "}
                    <strong>
                      {moment(this.state._expiredAt).format("dddd, LL HH:mm")}
                    </strong>
                  .
                  </Text>
                ) : null}
                {this.state._params.transactionStatus === "pending" &&
                  !isFromKickApp() ? (
                  <ButtonSnapPay
                    ref={input => (this.buttonPayRef = input)}
                    snapToken={this.state._trxToken}
                    disabled={this.state._trxToken === null}
                    hide={this.state._trxToken === null}
                    className={"btn-green bold"}
                    color="success"
                    size="lg"
                    // block
                    redirectUrl={this.state._redirectUrl}
                    onSuccess={this._handleOnSuccess}
                    onPending={this._handleOnPending}
                    onError={this._handleOnError}
                    onClose={this._handleOnToggleAlert}
                  >
                    {this.props.dataMidtrans.isFetch ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center"
                        }}
                      >
                        <ReactLoading
                          type={"bars"}
                          height={20}
                          width={20}
                          color="#fff"
                        />
                        <span style={{ marginLeft: ".5rem" }}>PLEASE WAIT</span>
                      </div>
                    ) : this.state._trxId ? (
                      HAS_CONFIRM_PAYMENT_MSG
                    ) : (
                      NOT_CONFIRM_PAYMENT_MSG
                    )}
                  </ButtonSnapPay>
                ) : !isFromKickApp() ? (
                  <Link
                    style={{ marginTop: "1rem", cursor: "pointer" }}
                    className="btn-green bold btn btn-success btn-lg"
                    to="/"
                    title="Back to homepage"
                  >
                    BACK TO HOME
                  </Link>
                ) : null}
                <Text style={{ marginTop: "1rem", marginBottom: 0 }}>
                  If you have any questions about your order, please contact our
                team by email to{" "}
                  <a
                    href="mailto:info@kickavenue.com"
                    title="Mail to info@kickavenue.com"
                  >
                    info@kickavenue.com
                </a>
                . Please put your invoice number into your subject email.
              </Text>
              </Box>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getMidtransDetail: invoice => dispatch(doGetMidtransPaymentDetail(invoice)),
  getPaymentDetail: invoice => dispatch(doGetPayment(invoice)),
  doFetchProductAddon: (payload) => dispatch(doFetchProductAddon(payload)),
});

const mapStateToProps = ({
  dataPayment: {
    midtrans: { details },
    paymentDetail,
    productAddon
  }
}) => ({
  dataMidtrans: details,
  paymentDetail,
  productAddon
});
const componentConnect = connect(mapStateToProps, mapDispatchToProps);
export default componentConnect(withScrollTo(PagePaymentResult));
